import type { ThemeProps } from "models/styles/theme";
import styled from "styled-components/macro";
import { ParagraphLarge } from "styles/elements/Texts";

export const StyledHeader = styled.header<ThemeProps>`
  width: 93%;
  margin: auto;
  display: flex;
  justify-content: space-between;
  align-items: center;

  * > button {
    margin-left: 1rem;
    padding: 0.5rem 1rem;
  }

  * > span {
    font-weight: 400;
    font-size: ${(props: ThemeProps) => props.theme.font.size._12};
  }
`;

export const StyledBody = styled.div<ThemeProps>`
  background: #e5e5e5;
  height: 91%;
  margin: auto;
`;

export const StyledInnerBody = styled.div<ThemeProps>`
  margin: auto;
  padding-top: 3rem;
  width: 70%;

  * > p {
    font-size: ${(props: ThemeProps) => props.theme.font.size._16};
  }
`;

export const StyledForm = styled.div<ThemeProps>`
  background: white;
  max-width: 100%;
  display: flex;
  justify-content: center;
  padding: 2rem 2rem;
  gap: 3rem;
`;

export const StyledInnerForm = styled.div<ThemeProps>`
  width: 400px;
  display: flex;
  flex-direction: column;
`;

export const StyledParagraph = styled(ParagraphLarge)<ThemeProps>`
  font-size: ${(props: ThemeProps) => props.theme.font.size._16};
  color: ${({ theme }: ThemeProps) => theme.palette.neutral._400};
`;
